var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9999 12.6004C10.0927 12.6004 12.5999 10.0932 12.5999 7.00039C12.5999 3.9076 10.0927 1.40039 6.9999 1.40039C3.90711 1.40039 1.3999 3.9076 1.3999 7.00039C1.3999 10.0932 3.90711 12.6004 6.9999 12.6004ZM7.4199 5.32039C7.4199 5.08843 7.23186 4.90039 6.9999 4.90039C6.76794 4.90039 6.5799 5.08843 6.5799 5.32039L6.5799 6.58041H5.3199C5.08794 6.58041 4.8999 6.76845 4.8999 7.00041C4.8999 7.23236 5.08794 7.42041 5.3199 7.42041H6.5799V8.68039C6.5799 8.91235 6.76794 9.10039 6.9999 9.10039C7.23186 9.10039 7.4199 8.91235 7.4199 8.68039L7.4199 7.42041H8.6799C8.91186 7.42041 9.0999 7.23236 9.0999 7.00041C9.0999 6.76845 8.91186 6.58041 8.6799 6.58041H7.4199V5.32039Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus.f1a5d05b.svg";
export { ForwardRef as ReactComponent };